import { jsx as _jsx } from "react/jsx-runtime";
/*
 * @Author: zhulu
 * @Date: 2022-04-07 14:49:46
 * @Description: 占位组件
 */

import classNames from 'classnames';
export default function Placeholder() {
  return _jsx("div", Object.assign({
    className: classNames('flex justify-center items-center bg-blue-200 py-3')
  }, {
    children: _jsx("span", Object.assign({
      className: 'py-1 px-10 text-small bg-blue-400 text-white'
    }, {
      children: "\u7EC4\u4EF6\u653E\u7F6E\u533A\u57DF"
    }))
  }));
}
Placeholder.displayName = 'Placeholder';